export default "__VITE_ASSET__fqEpViRF__"